class QuantityBundle extends HTMLElement{
    constructor() {
        super();
    }
        connectedCallback() {
            this.cartDrawer = document.querySelector('cart-drawer');
            this.quantityBundleSubmits = this.querySelectorAll('.quantity-bundle__submit');
            this.mainProductId = this.querySelector("#variant-id").value;
            this.variantBundle = this.hasAttribute("data-variant");
            this.subscriptionMainID = this.hasAttribute("data-subscription") ? this.getAttribute("data-subscription") : null;
            this.checkQuantity();
            if (this.quantityBundleSubmits && this.quantityBundleSubmits.length > 0 ) {
                this.quantityBundleSubmits.forEach(quantityBundleSubmit => {
                    
                    quantityBundleSubmit.addEventListener('click', this.handleAddToCart.bind(this));
                });
                
            }
            this.purchaseInputs = this.querySelectorAll("quantity-bundle input[name='quantity-bundle']");
            this.initMedia();
            this.addListeners();
            this.purchaseInputs.forEach((purchaseInput)=>{
                    purchaseInput.addEventListener("change", function(e){   
                        const featuredImage = purchaseInput.getAttribute("data-media-id");
                            if(featuredImage){
                                const productMedia = document.querySelector('product-media');
                                        productMedia.setActiveMedia(
                                        parseInt(featuredImage)
                                );
                            }
                    })
                    })
        }


        initMedia(){
            const activeInputId = this.querySelector("quantity-bundle input[name='quantity-bundle']:checked")?.getAttribute("data-media-id");
            if(activeInputId){
                const productMedia = document.querySelector('product-media');
                                        productMedia.setActiveMedia(
                                        parseInt(activeInputId)                         
                                );
            }
        }
        checkQuantity(){
            const bagContainer = this.querySelector('.quantity-bundle__bag-quantity');
            if(bagContainer){
                if(this.hasAttribute("data-variant")){
                     const checkedQuantity = this.querySelector('input[name="quantity-bundle"]:checked')?.hasAttribute("data-subscription-quantity") ? this.querySelector('input[name="quantity-bundle"]:checked')?.getAttribute("data-subscription-quantity") : 1;
                        if(checkedQuantity){
                            if(checkedQuantity > 1){
                                bagContainer.innerText = checkedQuantity + " bags";
                            } else{
                                bagContainer.innerText = checkedQuantity + " bag";
                            }
                        }
                } else{
                    const checkedQuantity = this.querySelector('input[name="quantity-bundle"]:checked')?.value;
                        if(checkedQuantity){
                            if(checkedQuantity > 1){
                                bagContainer.innerText = checkedQuantity + " bags";
                            } else{
                                bagContainer.innerText = checkedQuantity + " bag";
                            }
                        }
                }
                

            }
        }
        addListeners(){
            this.addEventListener("click", function(e){
                if(e.target.closest("label.quantity-bundle__item")){
                    this.checkQuantity();
                }
            })
        }

        async handleAddToCart(button) {
        const addButton = button.target;
        const loadingOverlay = addButton?.querySelector('.loading-overlay');
        
        if (!addButton || addButton.disabled) return;
    
        addButton.disabled = true;
        loadingOverlay?.classList.remove('hidden');
        try {
            const checkedQuantity = this.querySelector("input[name='quantity-bundle']:checked").value;
            const checkedVariant = this.querySelector(".quantity-bundle--subscription")?.hasAttribute("open") ? this.querySelector("input[name='quantity-bundle-subscription']:checked").closest(".quantity-bundle__item") : this.querySelector("input[name='quantity-bundle']:checked").closest(".quantity-bundle__item");
            const gifts = checkedVariant.querySelectorAll(".quantity-bundle__gift[data-product]");
            const currentVariantId = checkedVariant.querySelector("#current-variant-id")?.value;
            let sellingPlan = "";
            if(!this.variantBundle){
                sellingPlan = this.subscriptionMainID
            } else{
                sellingPlan = checkedVariant.hasAttribute("data-variant-subscription") ? checkedVariant.getAttribute("data-variant-subscription") : null;
            }
            this.cartDrawer = document.querySelector('cart-drawer');
            const formData = new FormData();
            const variantID = this.variantBundle ? currentVariantId : this.mainProductId;
            const quantity = this.variantBundle ? 1 : parseInt(checkedQuantity);
             formData.append("id", variantID);
             formData.append("quantity", quantity);
             sellingPlan ? formData.append("selling_plan", sellingPlan) : null;
            if(gifts && gifts.length>0){
                gifts.forEach((gift, index)=>{
                const variantId = gift.dataset.product;
                formData.append(`items[${index}][id]`, variantId);
                formData.append(`items[${index}][quantity]`, '1');
                })
            }
             if (this.cartDrawer) {
                const sections = this.cartDrawer.getSectionsToRender?.()?.map(section => section.section);
                if (sections) {
                    formData.append('sections', sections.join(','));
                }
                formData.append('sections_url', window.location.pathname);
                }
                console.log(...formData)
           // Add items to cart
                const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: formData
                });

                if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Failed to add items to cart');
                }
                
                const result = await response.json();
                // Update cart drawer if available
                if (this.cartDrawer && result.sections) {
                this.cartDrawer.renderContents(result);
                this.cartDrawer.open();
                }

                // Dispatch cart update event
                document.dispatchEvent(new CustomEvent('cart:updated', { 
                detail: { items: result.items || [] }
                }));
        
        
        } catch (error) {
            console.error('Error adding items to cart:', error);
        } finally{
             // Hide loading state
            loadingOverlay?.classList.add('hidden');
            addButton.disabled = false;
        }
    }
}
if (!customElements.get('quantity-bundle')) {
    customElements.define('quantity-bundle', QuantityBundle);
  }



